<template>
  <div class="settings-loc-container m-4">
    <div
      class="d-flex flex-row justify-content-between align-items-center mb-3"
    >
      <h5 class="mb-0">Discharge Reasons</h5>
      <b-button
        class="pt-2 pb-2"
        size="sm"
        @click="addDischargeReason"
        variant="primary"
        >New</b-button
      >
    </div>
    <grid
      :groupFeature="false"
      :columns="columns"
      :autoHeight="true"
      :data="dischargeReasons"
      :columnLines="false"
      :searchFeature="true"
      :stripeFeature="false"
    ></grid>
    <b-modal
      centered
      ref="form-modal"
      :title="formId ? 'Edit Discharge Reason' : 'Add Discharge Reason'"
      header-bg-variant="primary"
      header-text-variant="white"
      @ok="submitDischargeReason"
      no-close-on-backdrop
      header-class="bg-purple"
    >
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="secondary" @click="cancel()">
          Cancel
        </b-button>
        <b-button variant="primary" @click="ok()">
          Save
        </b-button>
      </template>
      <b-form-group
        label="Name"
        :state="formErrors.name.length == 0 ? null : false"
        :invalid-feedback="formErrors.name.join(', ')"
      >
        <b-form-input
          v-model="form.name"
          maxLength="100"
          :state="formErrors.name.length == 0 ? null : false"
        ></b-form-input>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import Grid from "../../third_party/grid/Grid.vue";
import dischargeReasonServer from "../../server/dischargeReason";
import { mapActions, mapState } from "vuex";
import { validateRequired } from "../../helpers/validation";

export default {
  name: "DischargeReasonCrud",
  components: {
    Grid
  },
  data() {
    return {
      formId: undefined,
      form: {
        name: "",
        type: "Generic"
      },
      formErrors: {
        name: []
      }
    };
  },
  mounted() {
    this.fetchDischargeReasons();
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess"]),
    ...mapActions("client", ["fetchDischargeReasons"]),
    validateDischargeReasonSubmit() {
      let withoutErrors = true;

      this.formErrors.name = [];
      if (!validateRequired(this.form.name)) {
        this.formErrors.name.push("This field is required");
        withoutErrors = false;
      }

      return withoutErrors;
    },
    async submitDischargeReason(modalEvent) {
      modalEvent.preventDefault();
      this.form.position = this.form.position || 0;
      const result = this.validateDischargeReasonSubmit();
      if (result) {
        const formData = {
          ...this.form
        };
        if (this.formId) {
          await dischargeReasonServer.update(this.formId, formData);
        } else {
          await dischargeReasonServer.create(formData);
        }
        this.fetchDischargeReasons();
        this.showAlertSuccess();
        this.$refs["form-modal"].hide();
      }
    },
    addDischargeReason() {
      this.formId = undefined;
      this.form = {
        name: "",
        type: "Generic"
      };
      this.formErrors = {
        name: []
      };
      this.$refs["form-modal"].show();
    }
  },
  computed: {
    ...mapState("client", {
      dischargeReasons: state => state.dischargeReasons
    }),
    columns() {
      let columns = [
        {
          text: "Name",
          field: "name",
          width: "90%",
          editor: false
        },
        {
          text: "",
          type: "action",
          cellCls: "pointer-cell",
          field: "action",
          align: "right",
          width: "10%",
          actions: [
            {
              tooltip: "Edit",
              renderer: ({ record }) =>
                record.data.readOnly
                  ? ""
                  : `<img class="b-action-item mr-2" src="${
                      this.isStandalone()
                        ? `/icons/edit.svg`
                        : `/desktop/icons/edit.svg`
                    }">`,
              onClick: async ({ record }) => {
                this.formId = record.id;
                this.form = {
                  ...record.data
                };
                this.formErrors = {
                  name: [],
                  position: []
                };
                this.$refs["form-modal"].show();
              }
            },
            {
              tooltip: "Delete",
              renderer: ({ record }) =>
                record.data.readOnly
                  ? ""
                  : `<img class="b-action-item" src="${
                      this.isStandalone()
                        ? `/icons/delete.svg`
                        : `/desktop/icons/delete.svg`
                    }">`,
              onClick: ({ record }) => {
                this.$dialog
                  .confirm(
                    {
                      title: "Are you sure you want to delete this record?"
                    },
                    {
                      view: "confirm-delete"
                    }
                  )
                  .then(async () => {
                    await dischargeReasonServer.delete(record.id);
                    this.fetchDischargeReasons();
                    this.showAlertSuccess();
                  })
                  .catch(function() {});
              }
            }
          ]
        }
      ];
      return columns;
    }
  }
};
</script>

<style>
.settings-loc-container .b-grid-container .b-container {
  max-height: calc(100vh - 281px);
}
</style>
